module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.btnConfirm),
      expression: "btnConfirm"
    }],
    staticClass: "btn btn-xs btn-danger",
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("削除")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.btnDelete),
      expression: "btnDelete"
    }],
    staticClass: "btn btn-xs btn-danger",
    on: {
      "click": _vm.del
    }
  }, [_vm._v("完全削除")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-540835d5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BtnDelete.vue
// module id = 457
// module chunks = 1